import { render, staticRenderFns } from "./ExpenseEditModal.vue?vue&type=template&id=35c55c04"
import script from "./ExpenseEditModal.vue?vue&type=script&lang=js"
export * from "./ExpenseEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports